import * as angular from 'angular';
import * as _ from 'lodash';

export default (ngModule) => {

  ngModule
    .directive('layoutFillHeight', function layoutFillHeight($window) {
      return {
        restrict: 'A',
        scope: {
          height: '=layoutFillHeight'
        },
        link: link
      };

      function link(scope, elem) {

        setHeight();
        angular.element($window).bind('resize', _.debounce(setHeight, 500));

        function setHeight() {
          scope.$applyAsync(() => {
            var height = ($window.document.documentElement.offsetHeight - scope.height) + 'px';
            elem.css('height', height);
            elem.css('max-height', height);
          });
        }
      }
    });
};



/** WEBPACK FOOTER **
 ** ./common/decorators/layout-fill-height.directive.ts
 **/